import _ from 'underscore';

export const campaignThirdPartyVendors = {
  ISPOT: 'ISPOT',
  DV: 'DV',
};

export const reachVendors = [
  campaignThirdPartyVendors.ISPOT,
];

export const verificationVendors = [
  campaignThirdPartyVendors.DV,
];

export const campaignThirdPartyVendorNames = {
  ISPOT: _TL_('iSPOT'),
  DV: _TL_('DoubleVerify'),
};

export const thirdPartyMeasurementTrackingVendorHeader = {
  ISPOT: _TL_('Reach vendor'),
  DV: _TL_('Verification vendor'),
};

export const thirdPartyVendorHeaderPopupTopic = {
  ISPOT: 'pop_BA_Measurement_Reach',
  DV: 'pop_BA_Measurement_Verification',
};

export const thirdPartyMeasurementTrackingVendorField = {
  ISPOT_brandId: 'brandId',
  ThirdPartyMeasurement_setting: 'setting',
};

const thirdPartySettingError = {
  ISPOT_brandId_shouldNotBeEmpty: _TL_('iSpot Brand ID is required'),
  ISPOT_brandId_shouldBeNumeric: _TL_('iSpot Brand ID should be numeric'),
  ISPOT_brandId_brandIdTooLong: _TL_('iSpot Brand ID should be no more than 7 characters'),
  DV_linkNotEstablished: _TL_('DoubleVerify link not established'),
};

export const vendorNameKey = 'vendorName';
export const settingEnabledKey = 'enabled';
const numericPattern = /^\d+$/;
const maxBrandIdLength = 7;
export const VerifiedTrackingSettingKey = 'VerifiedTrackingSettings';

const ispotValidator = ({ setting, i18n }) => {
  const errors = [];
  const brandId = _.get(setting, [thirdPartyMeasurementTrackingVendorField.ISPOT_brandId]);
  if (_.isEmpty(brandId)) {
    errors.push(i18n.getString(thirdPartySettingError.ISPOT_brandId_shouldNotBeEmpty));
    return errors;
  }

  if (numericPattern.test(brandId) === false) {
    errors.push(i18n.getString(thirdPartySettingError.ISPOT_brandId_shouldBeNumeric));
    return errors;
  }

  if (brandId.length > maxBrandIdLength) {
    errors.push(i18n.getString(thirdPartySettingError.ISPOT_brandId_brandIdTooLong));
  }
  return errors;
};

const dvValidator = ({ setting, i18n, doubleVerifyLinkEstablished }) => {
  const errors = [];

  if (setting.enabled && !doubleVerifyLinkEstablished) {
    errors.push(i18n.getString(thirdPartySettingError.DV_linkNotEstablished));
    return errors;
  }

  return errors;
};

export const isVendorSelectedInSetting = (settings, vendorName) => {
  const foundSetting = _.find(settings, setting => setting[vendorNameKey] === vendorName);
  if (foundSetting) {
    return _.get(foundSetting, settingEnabledKey, false);
  }
  return false;
};

export const thirdPartySettingValidatorMap = {
  ISPOT: ispotValidator,
  DV: dvValidator,
};

export const createVerifiedTrackingSettingViewModel = value => ({
  [VerifiedTrackingSettingKey]: value,
});

